import React from "react";
import styled from "styled-components";
import { Button, Modal, Typography } from "@mui/material";
import { lineOAUrl } from "src/config";

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #ebebeb;
  width: 90%;
  height: 200px;
  padding: 5px 0;
  &:focus {
    outline: none;
  }

  .content {
    height: 100%;
    margin: 40px 20px;
    .content_item {
      margin: 5px 0;
      font-size: 1.4rem;
    }
    .close_btn {
      border-radius: 0px;
      width: 100%;
      text-align: center;
      color: #fff;
      padding: 1rem 0;
      background: #2f3335;
      margin: 0 auto;
      margin-top: 1.6rem;
      font-size: 1rem;
    }
  }
`;

const ActivityEndModal = ({ open, setOpen }) => {
  const goLineOa = () => {
    window.location.replace(lineOAUrl);
  };
  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Wrapper>
        <div className="content">
          <Typography className="content_item" align="center">
            您已完成綁定，歡迎繼續
            <br />
            探索更多品牌資訊
          </Typography>
          <Button className="close_btn" onClick={goLineOa}>
            回到La Prairie官方帳號
          </Button>
        </div>
      </Wrapper>
    </Modal>
  );
};
export default ActivityEndModal;
